








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { addDays } from 'date-fns';
import { DatePicker } from '@/components/form';
import Button from '@/components/ext/Button.vue';
import { RequestUsersList } from './components';
import { Request, Users } from './types';
import Select from '@/components/form/Select.vue';
const isNull = (value: null | Date) => value === null;

@Component({
  components: {
    DatePicker,
    RequestUsersList,
    Button,
    Select,
  },
})
export default class RequestForm extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly users!: Users;

  @Prop({ type: Object, default: null })
  readonly errors!: any;

  today: Date = new Date();
  request: Request = {
    dateStudyFrom: null,
    dateStudyTo: null,
    // students - временно, потом убрать. раньше можно было нескольок полз, потом решили убрать этот функцинал
    studentId: this.$store.state.user.profile.id,
    eduLevel: null,
  };

  get isDisabled() {
    const { dateStudyFrom, dateStudyTo, eduLevel } = this.request;
    // console.log(this.request);
    return !eduLevel || !(isNull(dateStudyFrom) === isNull(dateStudyTo));
  }

  get eventOrderEduLevelsDict() {
    return this.$store.state.eventOrderEduLevelsDict.map((el: any) => ({
      value: el.id,
      text: el.name,
    }));
  }

  get fromDisabledDates() {
    const { request, today } = this;
    return { to: addDays(today, -1), from: request.dateStudyTo };
  }

  get toDisabledDates() {
    const { request, today } = this;
    return { to: request.dateStudyFrom || addDays(today, -1) };
  }

  addCheckedChildren(selected: Array<string>) {
    // this.request.students = selected;
  }

  submitRequest() {
    if (!this.isDisabled) this.$emit('submitRequest', this.request);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/request/components/requestform/RequestForm.vue